type LegendToggleProps = {
  label: string;
  color: string;
  active: boolean;
  onClick: () => void;
};

// Shared legend chip used by the Fct forecast/comparison charts: a swatch + label
// that strikes through and greys out when its series is hidden.
export function LegendToggle({ label, color, active, onClick }: LegendToggleProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center gap-2 font-semibold ${
        active ? 'text-slate-700' : 'text-slate-400 line-through'
      }`}
    >
      <span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: active ? color : '#cbd5e1' }} />
      {label}
    </button>
  );
}
